import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Truck } from 'lucide-react';
import { CAUSALI_TRASPORTO, ASPETTO_BENI } from '../../lib/documentiConst';

/** Card campi specifici DDT (trasporto). onChange(patch) fa merge su dati_ddt. */
export const DatiDdtCard = ({ dati, onChange }) => (
  <Card className="rounded-md border-amber-500/30 bg-amber-500/5">
    <CardHeader className="pb-2">
      <CardTitle className="text-sm font-mono uppercase flex items-center gap-2">
        <Truck className="h-4 w-4 text-amber-500" />
        Dati Trasporto DDT
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <Label className="text-xs font-mono uppercase">Causale Trasporto</Label>
          <Select value={dati.causale_trasporto} onValueChange={(value) => onChange({ causale_trasporto: value })}>
            <SelectTrigger className="rounded-md"><SelectValue /></SelectTrigger>
            <SelectContent className="rounded-md">
              {CAUSALI_TRASPORTO.map((c) => (<SelectItem key={c} value={c}>{c}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Aspetto Beni</Label>
          <Select value={dati.aspetto_beni} onValueChange={(value) => onChange({ aspetto_beni: value })}>
            <SelectTrigger className="rounded-md"><SelectValue /></SelectTrigger>
            <SelectContent className="rounded-md">
              {ASPETTO_BENI.map((a) => (<SelectItem key={a} value={a}>{a}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Porto</Label>
          <Select value={dati.porto} onValueChange={(value) => onChange({ porto: value })}>
            <SelectTrigger className="rounded-md"><SelectValue /></SelectTrigger>
            <SelectContent className="rounded-md">
              <SelectItem value="Franco">Franco</SelectItem>
              <SelectItem value="Assegnato">Assegnato</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-4">
        <div>
          <Label className="text-xs font-mono uppercase">N. Colli</Label>
          <Input
            type="number"
            value={dati.numero_colli}
            onChange={(e) => onChange({ numero_colli: parseInt(e.target.value) || 1 })}
            className="rounded-md"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Peso (kg)</Label>
          <Input
            type="number"
            step="0.1"
            value={dati.peso_kg}
            onChange={(e) => onChange({ peso_kg: e.target.value })}
            className="rounded-md"
            placeholder="Opzionale"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Data Trasporto</Label>
          <Input
            type="date"
            value={dati.data_trasporto}
            onChange={(e) => onChange({ data_trasporto: e.target.value })}
            className="rounded-md"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Ora</Label>
          <Input
            type="time"
            value={dati.ora_trasporto}
            onChange={(e) => onChange({ ora_trasporto: e.target.value })}
            className="rounded-md"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label className="text-xs font-mono uppercase">Vettore</Label>
          <Input
            value={dati.vettore}
            onChange={(e) => onChange({ vettore: e.target.value })}
            className="rounded-md"
            placeholder="Nome vettore/corriere"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Destinazione Diversa</Label>
          <Input
            value={dati.destinazione_diversa}
            onChange={(e) => onChange({ destinazione_diversa: e.target.value })}
            className="rounded-md"
            placeholder="Se diversa dalla sede cliente"
          />
        </div>
      </div>
    </CardContent>
  </Card>
);
